/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { KpiPreviewParameterDtoOptionsInner } from './kpi-preview-parameter-dto-options-inner';
import { KpiParameterColumnDto } from './kpi-parameter-column-dto';


export interface KpiPreviewParameterDto { 
    /**
     * KPI parameter name that can be sent to execute.
     */
    name: string;
    /**
     * Parameter type used by preview controls and execution binding.
     */
    type: KpiPreviewParameterDto.TypeEnum;
    /**
     * Whether this parameter must be supplied before executing the KPI.
     */
    required: boolean;
    /**
     * Default value used when the preview does not supply this parameter.
     */
    defaultValue?: object;
    /**
     * True when the parameter takes several values (send a list).
     */
    multiple?: boolean;
    /**
     * column parameters only: the column the condition filters.
     */
    column?: KpiParameterColumnDto;
    /**
     * Available options when this parameter has an option source: plain values, or { value, label } from a two-column source. At most limit (default 100).
     */
    options?: Array<KpiPreviewParameterDtoOptionsInner>;
    /**
     * Whether options were served from cache. Omitted when no options lookup was needed.
     */
    cached?: boolean;
    /**
     * Whether more options matched than limit. Omitted when no options lookup was needed.
     */
    truncated?: boolean;
}
export namespace KpiPreviewParameterDto {
    export const TypeEnum = {
        Date: 'date',
        Enum: 'enum',
        Text: 'text',
        Number: 'number',
        TimeGrain: 'timeGrain',
        DateRange: 'dateRange',
        Column: 'column'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


